import React from 'react';

const SubHeader = (props) => {
    const { title, img } = props;
 
    return(
        
        <div className="outerdivsubheader">
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <h2 className='welcome mb-0'>{title}</h2>
                </div>
                {img !== undefined && 
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div className='titleImgHeader imgHeaderWdt'>
                        <img src={img} /> 
                    </div>
                </div>}
            </div>
        </div>
        

    )
}
export default SubHeader;